import React from 'react'

import Base from '../_Base'

const MpaR = (props) => (
  <Base width="36" height="24" viewBox="0 0 36 24" fill="none" {...props}>
    <rect x="0.5" y="0.5" width="35" height="23" rx="1.5" stroke="#8C8C8C" />
    <path
      d="M17.016 11.415C17.43 11.415 17.781 11.364 18.069 11.262C18.363 11.154 18.603 11.007 18.789 10.821C18.975 10.635 19.11 10.419 19.194 10.173C19.278 9.921 19.32 9.651 19.32 9.363C19.32 8.787 19.131 8.337 18.753 8.013C18.381 7.689 17.802 7.527 17.016 7.527H15.792V11.415H17.016ZM23.478 18.363H20.724C20.214 18.363 19.848 18.171 19.626 17.787L17.448 13.98C17.346 13.818 17.232 13.701 17.106 13.629C16.98 13.551 16.8 13.512 16.566 13.512H15.792V18.363H12.75V5.25H17.016C17.964 5.25 18.771 5.349 19.437 5.547C20.109 5.739 20.655 6.009 21.075 6.357C21.501 6.705 21.81 7.116 22.002 7.59C22.194 8.064 22.29 8.58 22.29 9.138C22.29 9.564 22.233 9.966 22.119 10.344C22.005 10.722 21.837 11.073 21.615 11.397C21.393 11.715 21.117 12 20.787 12.252C20.463 12.504 20.088 12.711 19.662 12.873C19.86 12.975 20.046 13.104 20.22 13.26C20.394 13.41 20.55 13.59 20.688 13.8L23.478 18.363Z"
      fill="#8C8C8C"
    />
  </Base>
)

export default MpaR
